"use strict";module.exports=function(baseString,searchedString){return 0===baseString.indexOf(searchedString,0)};
